import { BillingInformation } from "./billing-info";
import { ShippingInformation } from "./shipping-info";
import { ProductInformation } from "./product-info";
import { AddressInformation } from "./address-detail-info";

export class OrderDetailInformation {
    userName: string;
    orderNumber: string;
    webOrderNumber: string;
    orderDate: any;
    source: string;
    billingInfo: BillingInformation;
    shippingInfo: ShippingInformation;
    subTotal: number;
    totalSaving: number;
    shipping: number;
    tax: number;
    total: number;
    totalCC: number;
    discount:number;
    productInfo: ProductInformation[];
    deliveryPreferenceId?: number;
    distrubutorId?:string;
    name?:string;
    addresses : AddressInformation[];
    address?:AddressInformation;
    webOrderId?:string;
    countryCode?:string;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/order-detail-info.ts